"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _createStyled = require("../../../utils/createStyled");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _select = _interopRequireDefault(require("../style/select"));

var _transformIconToComponent = _interopRequireDefault(require("../../../utils/transformIconToComponent"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Select = function Select(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      open = _ref.open,
      close = _ref.close,
      forwardedRef = _ref.forwardedRef,
      qaNode = _ref.qaNode,
      qaValue = _ref.qaValue,
      tabIndex = _ref.tabIndex,
      value = _ref.value,
      selected = _ref.selected,
      active = _ref.active,
      error = _ref.error,
      hover = _ref.hover,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      theme = _ref.theme,
      placeholder = _ref.placeholder;
  var styles = (0, _select["default"])(theme, {
    error: error,
    disabled: disabled,
    readOnly: readOnly
  }, {
    hover: hover,
    active: active
  }),
      dropDownIcon = (0, _transformIconToComponent["default"])(_objectSpread({
    source: icon
  }, styles.icon));
  return _react["default"].createElement(_createStyled.Styled.Button, {
    styles: styles.wrapper,
    type: "button",
    title: title,
    onClick: active ? close : open,
    ref: forwardedRef,
    "data-qa-node": qaNode,
    "data-qa-value": qaValue,
    tabIndex: tabIndex
  }, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: selected ? styles.field : styles.placeholder
  }, _react["default"].createElement(_createStyled.Styled.Span, {
    styles: styles.overflowWrapper
  }, value || placeholder)), _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.iconWrapper
  }, dropDownIcon));
};

Select.defaultProps = {
  tabIndex: '0'
};
Select.propTypes = {
  title: _propTypes["default"].string,
  icon: _propTypes["default"].any,
  open: _propTypes["default"].func,
  close: _propTypes["default"].func,
  select: _propTypes["default"].func,
  forwardedRef: _propTypes["default"].object,
  qaNode: _propTypes["default"].string,
  qaValue: _propTypes["default"].string,
  tabIndex: _propTypes["default"].string,
  value: _propTypes["default"].any,
  selected: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  hover: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  theme: _propTypes["default"].object,
  placeholder: _propTypes["default"].string,
  list: _propTypes["default"].array
};
var _default = Select;
exports["default"] = _default;